import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-foreground-300 mb-4">404</h1>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-800 mb-2">
            页面走丢了
          </h2>
          <p className="text-sm text-foreground-500 mb-6">
            您查找的页面不存在，可能已经被移除或地址输入有误
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link
              to="/"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line mr-1"></i>返回首页
            </Link>
            <Link
              to="/category/all"
              className="bg-background-100 hover:bg-background-200 text-foreground-700 px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-1"></i>浏览漫画
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}